<template>

  <div class="guild">
    <div class="banner">
      <img src="../../assets/img/banner@2x.fbb49aa7.jpg">
    </div>
    <div class="container-width">
      <p class="guild-title">
        申请要求
      </p>
      <ul class="guild-condition">
        <li class="gc-item gc-item-1">
          提供营业执照、开户许可证、法人身份证等公会申请资料
        </li>
        <li class="gc-item gc-item-2">
          准备至少5名有经验的主播资料，包括外站直播截图或者视频
        </li>
        <li class="gc-item gc-item-3">
          尽可能提供公会介绍、公会组成及公会外站流水等资料
        </li>
      </ul>
      <p class="guild-join">
        <a href="https://union.taqu.cn/login" target="_blank">
          申请入驻
        </a>
      </p>
      <div class="guild-contact">
        <div class="guild-email">
				<span class="guild-decorate">
				</span>
          <p data-v-02232f19="">
            雁来信离不开您宝贵的支持
            <br data-v-02232f19="">
            我们会认真对待每一条建议和意见
            <br data-v-02232f19="">
            对于您的建议和意见，雁来信感激不尽
            <br data-v-02232f19="">
            投诉建议邮箱：zhibo@taqu.cn
          </p>
        </div>
        <div class="guild-qq">
          <p data-v-02232f19="">
            直播商务合作
            <br data-v-02232f19="">
            扫描右侧企业微信群
            <br data-v-02232f19="">
            咨询雁来信直播政策及发
            <br data-v-02232f19="">
            展方向
          </p>
          <p class="guild-qq-qr">
          </p>
        </div>
      </div>
    </div>
  </div>


</template>

<script>
  export default {
    data () {
      return {
        msg: 'Welcome to Your Vue.js App'
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


  .guild{
    padding-top:80px;
    font-family:PingFang-SC-Medium,Microsoft YaHei,"\5FAE\8F6F\96C5\9ED1",PingFang SC,Heiti SC,SimHei
  }
  .guild-title{
    position:relative;
    padding-top:52px;
    color:#353535;
    font-size:36px;
    font-weight:700;
    line-height:50px;
    text-align:center
  }
  .guild-title:after,.guild-title:before {
    position:absolute;
    right:0;
    bottom:25px;
    width:402px;
    height:1px;
    background:#e6e6e6;
    content:""
  }
  .guild-title:before {
    left:0
  }
  .guild-condition{
    display:-webkit-box;
    display:-ms-flexbox;
    display:flex;
    -webkit-box-pack:justify;
    -ms-flex-pack:justify;
    justify-content:space-between;
    margin-top:52px
  }
  .gc-item{
    width:282px;
    height:300px;
    padding:169px 34px 0 35px;
    color:#353535;
    font-size:21px;
    line-height:31px
  }
  .gc-item-1{
    background:url(../../assets/img/1@2x.331180b5.png) no-repeat;
    background-size:contain
  }
  .gc-item-2{
    background:url(../../assets/img/2@2x.3ffa28c1.png) no-repeat;
    background-size:contain
  }
  .gc-item-3{
    background:url(../../assets/img/3@2x.aef06cff.png) no-repeat;
    background-size:contain
  }
  .guild-join{
    display:-webkit-box;
    display:-ms-flexbox;
    display:flex;
    -webkit-box-pack:center;
    -ms-flex-pack:center;
    justify-content:center;
    padding:66px 0 58px;
    text-align:center
  }
  .guild-join a{
    width:200px;
    height:56px;
    padding-right:18px;
    border-radius:32px;
    background:#ffd321 url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAMAAACfWMssAAAABGdBTUEAALGPC/xhBQAAAMZQTFRFKSEhKCIiKCMjKSIiKCIiKiIiKCEhKCEhKSEhKyMjKCIiKSMjKCIiKyMjLCMjKiQkQEBAKCEhKSEhKiIiKysrLicnKSkpKSEhKCEhKCIiKSEhLCEhgICAKiIiKiMjKyIiLS0tKSEhOycnKCIiVVVVKCEhLCQkKSEhMyYmKSIiKSIiLCQkKSIiKCEhKCIi////KSIiKSEhKCMjKCEhLi4uKSEhLCMjKCIiKSEhKCMjSSQkKCEhKyQkKiMjKCEhKSIiAAAAKCEhqvu62wAAAEF0Uk5TqZ9f+76G19iqO/Je8Ug6Twi/oIcGJxn13uSwLgJidFMRuQ3qA/5AxxSO+iNpmcwB0+dm/QvvHeN7Mwf8Tkn34gBke+BUAAAA1klEQVRIx+3WRxKCQBQEUMw5R8wRc1ZQgsj9L6UtJ/i9oFgw+1c1NdO/Z5QPuZQIRjAU0DHcMQVdz7vtGWh4v/UkoL2F3Jzkh+N0IGML+anmHpA9U34d/Qtkcia/x10X8riWB6B9hkzr8uRMVpBuSx65+xRy/pJntZmFLGrykA8OkG+bmI4GZKJAjNUIcnkl5nFoYbdmcJDdagrOipPXUREHQIHLa0FFjg25P1YZPahB9qujJq6Osl9WVWlZlf71WBfXI13IKvsE0I+Oo5LPXPR5iGDo4BfRBASIoW7SbAAAAABJRU5ErkJggg==) 139px 50% no-repeat;
    background-size:28px 28px;
    color:#282121;
    font-size:24px;
    font-weight:700;
    line-height:56px
  }
  .guild-contact{
    display:-webkit-box;
    display:-ms-flexbox;
    display:flex;
    -webkit-box-pack:justify;
    -ms-flex-pack:justify;
    justify-content:space-between;
    padding-bottom:150px
  }
  .guild-email{
    position:relative;
    padding-left:18px;
    font-size:14px;
    line-height:25px
  }
  .guild-decorate{
    position:absolute;
    top:0;
    left:0;
    width:8px;
    height:98px;
    border-radius:5px;
    background:#ffd321
  }
  .guild-qq{
    display:-webkit-box;
    display:-ms-flexbox;
    display:flex;
    -webkit-box-pack:justify;
    -ms-flex-pack:justify;
    justify-content:space-between;
    color:#a3a3a3;
    font-size:14px;
    line-height:20px
  }
  .guild-qq-qr{
    width:80px;
    height:80px;
    margin-right:2px;
    margin-left:26px;
    background:url(../../assets/img/qrcode.c50c12ec.jpg) no-repeat;
    background-size:80px 80px
  }

  .container-width {
    width: 1060px;
    margin: 0 auto;
  }
  

</style>



// WEBPACK FOOTER //
// src/views/Guild.vue